import { Component, OnInit } from '@angular/core';
import { ContenuSite } from '../../models/contenu-site.model';
import { ContenuSiteService } from '../../services/contenu-site.service';
import { JournalService } from '../../services/journal.service';

interface GroupeContenu {
  titre: string;
  cles: { cle: string; label: string }[];
}

@Component({
  selector: 'app-gestion-contenu',
  templateUrl: './gestion-contenu.component.html',
  styleUrls: ['./gestion-contenu.component.css']
})
export class GestionContenuComponent implements OnInit {

  // Regroupement par page pour que l'admin s'y retrouve facilement.
  // Un simple libelle humain associe a chaque cle technique.
  groupes: GroupeContenu[] = [
    {
      titre: "Accueil — L'âme du festival",
      cles: [
        { cle: 'about.texte', label: 'Paragraphe de présentation' },
        { cle: 'accueil.statNuits', label: 'Statistique : nuits de spectacles' },
        { cle: 'accueil.statArtistes', label: 'Statistique : artistes internationaux' },
        { cle: 'accueil.statSpectateurs', label: 'Statistique : spectateurs (en milliers)' }
      ]
    },
    {
      titre: 'Accueil — Citation "Vivre à Sousse"',
      cles: [
        { cle: 'quote.texte', label: 'Citation' },
        { cle: 'quote.auteur', label: 'Attribution' }
      ]
    },
    {
      titre: 'Accueil — Points forts (bandeau sous le hero)',
      cles: [
        { cle: 'hi.sun.t', label: 'Bloc 1 — titre' },
        { cle: 'hi.sun.s', label: 'Bloc 1 — sous-texte' },
        { cle: 'hi.unesco.t', label: 'Bloc 2 — titre' },
        { cle: 'hi.unesco.s', label: 'Bloc 2 — sous-texte' },
        { cle: 'hi.edition.t', label: 'Bloc 3 — titre' },
        { cle: 'hi.edition.s', label: 'Bloc 3 — sous-texte' },
        { cle: 'hi.aero.t', label: 'Bloc 4 — titre' },
        { cle: 'hi.aero.s', label: 'Bloc 4 — sous-texte' }
      ]
    },
    {
      titre: "Accueil — Bandeau final (Appel à l'action)",
      cles: [
        { cle: 'cta.titre', label: 'Titre' },
        { cle: 'cta.texte', label: 'Texte' }
      ]
    },
    {
      titre: 'Théâtre de Sidi Dhaher',
      cles: [
        { cle: 'theatre.intro', label: 'Paragraphe de présentation' },
        { cle: 'theatre.chiffrePlaces', label: 'Nombre de places' },
        { cle: 'theatre.chiffreInauguration', label: "Année d'inauguration" },
        { cle: 'theatre.chiffreSpectacles', label: 'Nombre de spectacles' }
      ]
    },
    {
      titre: 'Découvrir Sousse — Introduction',
      cles: [
        { cle: 'dec.intro', label: 'Paragraphe de présentation' }
      ]
    },
    {
      titre: 'Découvrir Sousse — 4 cartes infos',
      cles: [
        { cle: 'dec.acces.titre', label: 'Accès — titre' },
        { cle: 'dec.acces.texte', label: 'Accès — texte' },
        { cle: 'dec.heberg.titre', label: 'Hébergement — titre' },
        { cle: 'dec.heberg.texte', label: 'Hébergement — texte' },
        { cle: 'dec.gastro.titre', label: 'Gastronomie — titre' },
        { cle: 'dec.gastro.texte', label: 'Gastronomie — texte' },
        { cle: 'dec.visiter.titre', label: 'À visiter — titre' },
        { cle: 'dec.visiter.texte', label: 'À visiter — texte' }
      ]
    },
    {
      titre: "Découvrir Sousse — Comment s'y rendre",
      cles: [
        { cle: 'dec.transport.aeroport.titre', label: 'Aéroport — titre' },
        { cle: 'dec.transport.aeroport.texte', label: 'Aéroport — texte' },
        { cle: 'dec.transport.train.titre', label: 'Train — titre' },
        { cle: 'dec.transport.train.texte', label: 'Train — texte' },
        { cle: 'dec.transport.taxi.titre', label: 'Taxi — titre' },
        { cle: 'dec.transport.taxi.texte', label: 'Taxi — texte' },
        { cle: 'dec.transport.parking.titre', label: 'Parking — titre' },
        { cle: 'dec.transport.parking.texte', label: 'Parking — texte' }
      ]
    }
  ];

  valeurs: Record<string, ContenuSite> = {};
  messageConfirmation = '';
  enregistrementEnCours = false;

  constructor(
    private contenuSiteService: ContenuSiteService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    // Le contenu est deja charge globalement au demarrage de l'app (AppComponent) ;
    // on recharge quand meme ici pour etre certain d'avoir la version la plus recente.
    this.contenuSiteService.charger().subscribe(() => this.initialiserValeurs());
  }

  private initialiserValeurs(): void {
    this.groupes.forEach(groupe => {
      groupe.cles.forEach(({ cle }) => {
        const existant = this.contenuSiteService.obtenir(cle);
        this.valeurs[cle] = existant
          ? { ...existant }
          : { cle, texteFr: '', texteEn: '', texteAr: '' };
      });
    });
  }

  enregistrer(): void {
    this.enregistrementEnCours = true;
    const liste = Object.values(this.valeurs);
    this.contenuSiteService.enregistrerTous(liste).subscribe({
      next: () => {
        this.enregistrementEnCours = false;
        this.messageConfirmation = 'Contenu enregistré avec succès !';
        this.journalService.ajouter('Contenu éditorial du site mis à jour.').subscribe();
        setTimeout(() => this.messageConfirmation = '', 3000);
      },
      error: () => {
        this.enregistrementEnCours = false;
        alert("Erreur lors de l'enregistrement du contenu.");
      }
    });
  }
}
